<template>
  <div class="addPost">
    <div class="inner">
      <el-form
        :label-width="clientWidth > 900 ? '100px' : '50px'"
        label-position="left"
        :model="form"
        :rules="rules"
        hide-required-asterisk
        ref="form"
      >
        <el-form-item
          :label="$t('分類')"
          v-if="form.section === '1'"
          prop="community_type"
        >
          <el-select v-model="form.community_type" :placeholder="$t('请选择')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('分類')"
          prop="community_type"
          v-if="form.section === '2'"
        >
          <el-select v-model="form.strategy_type" :placeholder="$t('请选择')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('主題')"
          prop="article.title"
          :rules="{
            required: true,
            message: this.$t('請輸入主題'),
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="form.article.title"
            :placeholder="$t('請輸入文章主題')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <vue-editor
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="form.article.content"
          ></vue-editor>
          <div class="error-message" v-if="showError">
            {{ $t("请输入关键字") }}
          </div>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button @click="cancle">{{ this.$t("取消") }}</el-button>
        <el-button type="primary" @click="submit">{{
          this.$t("確認")
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import { publishArticle } from "@/api/communities";
import { mapState } from "vuex";
import Cookie from "js-cookie";
import { accountBase } from "@/utils/paccount";
export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        article: {},
        community_type: 1,
      },
      showError: false,
      options: [],
      rules: {
        community_type: [
          {
            required: true,
            message: this.$t("請選擇分類1"),
            trigger: "change",
          },
        ],
        strategy_type: [
          { required: true, message: this.$t("請選擇分類"), trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      clientWidth: (state) => state.screen.clientWidth,
    }),
  },
  created() {
    // this.$store.dispatch("getUser");
    this.gotoAuth();
    this.form.section = this.$route.query.type;
    if (this.$route.query.type === "1") {
      this.options = [
        {
          label: this.$t("聊天"),
          value: 1,
        },
        {
          label: this.$t("問題"),
          value: 2,
        },

        {
          label: this.$t("建議"),
          value: 3,
        },
      ];
    } else if (this.$route.query.type === "2") {
      this.options = [
        {
          label: this.$t("初学者"),
          value: 1,
        },
        {
          label: this.$t("职业"),
          value: 2,
        },

        {
          label: this.$t("物品"),
          value: 3,
        },
        {
          label: this.$t("其他"),
          value: 100,
        },
      ];
    }
  },
  methods: {
    gotoAuth() {
      let token = Cookie.get("token");
      if (!token) {
        window.localStorage.setItem("return_url", this.$route.fullPath);
        location.href = `${accountBase}/#/login?client_id=${this.$store.state.header.app_account_client_id}&return_url=${this.$store.state.header.app_redirect_url}`;
      }
    },
    submit() {
      console.log(this.form.article.content);
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.article.content) {
            const res = await publishArticle(this.form);
            if (res.status === 201) {
              this.$message.success(this.$t("發送成功"));
              this.$router.back();
            }
          } else {
            this.showError = true;
          }
        }
      });
    },
    cancle() {
      this.$router.back();
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      let _this = this;
      var formData = new FormData();
      formData.append("file", file);
      fetch(this.$baseUrl + "/1/communities/upload/", {
        method: "POST",
        body: formData,
      })
        .then((data) => {
          return data.json();
        })
        .then((ret) => {
          if (ret.url) {
            let url = ret.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          } else if (ret.detail)
            _this.$message({
              message: ret.detail,
              type: "success",
              offset: "100",
            });
          else
            _this.$message({
              message: _this.$t("上載失敗"),
              type: "error",
              offset: "100",
            });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.addPost {
  min-height: 80vh;
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  .inner {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    padding: 40px 0;
    @media only screen and (max-width: 900px) {
      padding: 40px 0;
      width: 90%;
    }
    .btn {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media only screen and (max-width: 900px) {
        margin-top: 20px;
      }
    }
  }
}
::v-deep .el-form-item {
  @media only screen and (max-width: 900px) {
    margin-bottom: 20px;
  }
}
::v-deep .el-form-item__label {
  @media only screen and (max-width: 900px) {
    font-size: 14px;
  }
}
::v-deep .el-input__inner {
  @media only screen and (max-width: 900px) {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
  }
}
::v-deep .el-select__caret {
  @media only screen and (max-width: 900px) {
    line-height: 30px;
  }
}
.el-button {
  @media only screen and (max-width: 900px) {
    line-height: 30px;
    height: 30px;
    width: 80px;
    font-size: 14px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    height: 100%;
    line-height: 30px;
  }
}
</style>
